import { render, staticRenderFns } from "./DispositionPage.vue?vue&type=template&id=46d9a1f4&scoped=true&"
import script from "./DispositionPage.vue?vue&type=script&lang=js&"
export * from "./DispositionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d9a1f4",
  null
  
)

export default component.exports